module.exports = __webpack_public_path__ + "assets/restart.7ede0c46.svg";